"use strict";

var _objectSpread = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/objectSpread");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var validator_1 = __importDefault(require("validator"));

var column_type_1 = __importStar(require("../constants/column-type"));

var item_filter_option_type_1 = __importDefault(require("../constants/item-filter-option-type"));

var app_1 = __importDefault(require("../constants/app"));

var UtilsLabel = __importStar(require("./label"));

function getType(data) {
  return data.type;
}

exports.getType = getType;

function getInput(data) {
  return data.input;
}

exports.getInput = getInput;

function checkEqual(column1, column2) {
  return column1.type === column2.type && column1.input === column2.input;
}

exports.checkEqual = checkEqual;

function getInitDataByType(column) {
  switch (column) {
    case column_type_1.default.SHORT:
      return {
        input: '',
        type: column_type_1.default.SHORT
      };
      break;

    default:
      console.warn('InCompleted code');
      break;
  }
}

exports.getInitDataByType = getInitDataByType;

function guessColumnTypeForEdit(columns) {
  var result = column_type_1.default.SHORT;
  var columnsLen = columns.length;

  if (columnsLen === 0) {
    return result;
  }

  var repeated = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var column = _step.value;
      var type = getType(column);

      if (result !== type) {
        result = type;
        repeated = 0;
      } else {
        repeated++;

        if (repeated >= 1) {
          return result;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return column_type_1.default.SHORT;
}

exports.guessColumnTypeForEdit = guessColumnTypeForEdit;

function checkIfPassGlobalSearch(column, query) {
  switch (column.type) {
    case column_type_1.default.SHORT:
    case column_type_1.default.LONG:
      {
        var input = column.input;

        if (!input) {
          return false;
        } else {
          input = lodash_1.default.toLower(input);
        }

        if (input.includes(lodash_1.default.toLower(query))) {
          return true;
        }

        break;
      }

    case column_type_1.default.BOOLEAN:
      {
        var _input = column.input;

        if (_input && (query === 'on' || query === 'yes')) {
          return true;
        }

        if (!_input && (query === 'off' || query === 'no')) {
          return true;
        }

        break;
      }

    case column_type_1.default.NUMBER:
      {
        var _input2 = column.input;
        var queryToNumber = lodash_1.default.toNumber(query);

        if (queryToNumber !== NaN) {
          if (_input2 === queryToNumber) {
            return true;
          }
        } else {
          var firstChar = query.charAt(0);

          if (firstChar === '>' || firstChar === '<') {
            var restChars = query.slice(1);
            var restCharsToNumber = lodash_1.default.toNumber(restChars);

            if (restCharsToNumber !== NaN) {
              if (firstChar === '>' && _input2 > restCharsToNumber) {
                return true;
              } else if (firstChar === '<' && _input2 < restCharsToNumber) {
                return true;
              }
            }
          }
        }

        break;
      }

    case column_type_1.default.RATE:
      {
        var _input3 = column.input;
        var value = lodash_1.default.get(_input3, 'value', null);

        if (value !== null && lodash_1.default.isFinite(value)) {
          var _queryToNumber = lodash_1.default.toNumber(query);

          if (_queryToNumber !== NaN) {
            if (value === _queryToNumber) {
              return true;
            }
          } else {
            var _firstChar = query.charAt(0);

            if (_firstChar === '>' || _firstChar === '<') {
              var _restChars = query.slice(1);

              var _restCharsToNumber = lodash_1.default.toNumber(_restChars);

              if (_restCharsToNumber !== NaN) {
                if (_firstChar === '>' && value > _restCharsToNumber) {
                  return true;
                } else if (_firstChar === '<' && value < _restCharsToNumber) {
                  return true;
                }
              }
            }
          }
        }

        break;
      }

    default:
      return false;
  }

  return false;
}

exports.checkIfPassGlobalSearch = checkIfPassGlobalSearch;

function extractSearchKeys(columns, label) {
  var keys = [];
  lodash_1.default.forEach(columns, function (column) {
    switch (column.type) {
      case column_type_1.default.SHORT:
        {
          var input = column.input;

          if (input) {
            if (label) {
              keys.push("".concat(label).concat(app_1.default.SEARCH_KEY_LABEL_DIVIDER).concat(lodash_1.default.toLower(input)));
            }
          }

          break;
        }

      case column_type_1.default.NUMBER:
        {
          if (label && lodash_1.default.isNumber(column.input)) {
            var _input4 = column.input;
            keys.push("".concat(label).concat(app_1.default.SEARCH_KEY_LABEL_DIVIDER).concat(_input4));
          }

          break;
        }

      case column_type_1.default.BOOLEAN:
        {
          if (label) {
            var _input5 = column.input;
            keys.push("".concat(label).concat(app_1.default.SEARCH_KEY_LABEL_DIVIDER).concat(_input5 ? 'on' : 'off'));
            keys.push("".concat(label).concat(app_1.default.SEARCH_KEY_LABEL_DIVIDER).concat(_input5 ? 'yes' : 'no'));
          }

          break;
        }

      default:
        break;
    }
  });
  return lodash_1.default.union(keys);
}

exports.extractSearchKeys = extractSearchKeys;

function getFilterData(column) {
  var columnTitle = getLabelContent(column);
  var type, input;

  switch (column.type) {
    case column_type_1.default.SHORT:
      {
        type = item_filter_option_type_1.default.SHORT_TEXT;
        input = column.input;
        break;
      }

    case column_type_1.default.LONG:
      {
        type = item_filter_option_type_1.default.LONG;
        input = null;
        break;
      }

    case column_type_1.default.RATE:
      {
        type = item_filter_option_type_1.default.RATE;
        input = null;
        break;
      }

    case column_type_1.default.NUMBER:
      {
        if (!lodash_1.default.isNumber(column.input)) {
          return null;
        }

        type = item_filter_option_type_1.default.NUMBER;
        input = column.input;
        break;
      }

    case column_type_1.default.BOOLEAN:
      {
        type = item_filter_option_type_1.default.BOOLEAN;
        input = null;
        break;
      }

    case column_type_1.default.RELATION:
      {
        type = item_filter_option_type_1.default.RELATION;
        input = column.input;
        break;
      }

    default:
      return null;
  }

  return {
    meta: {
      column_title: columnTitle,
      type: type
    },
    input: input
  };
}

exports.getFilterData = getFilterData;

function checkIfColumnSuitOneQueryBundle(column, queryBundle, items) {
  var meta = queryBundle.meta,
      selectedList = queryBundle.selectedList,
      userInput = queryBundle.userInput;

  if (checkIfColumnSuitAnyOfSelectedList(column, selectedList, items)) {
    return true;
  }

  if (userInput !== null && checkIfColumnSuitAnyOfUserInput(column, userInput, items)) {
    return true;
  }

  return false;
}

exports.checkIfColumnSuitOneQueryBundle = checkIfColumnSuitOneQueryBundle;

function checkIfColumnSuitAnyOfSelectedList(column, selectedList, items) {
  var type = column.type;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = selectedList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var selected = _step2.value;
      var meta = selected.meta,
          must = selected.must;

      switch (meta.type) {
        case item_filter_option_type_1.default.BOOLEAN:
          {
            if (type === column_type_1.default.BOOLEAN) {
              var compare = selected.compare;
              var input = column.input;

              if (compare.on && input || !compare.on && !input) {
                return true;
              }
            }

            break;
          }

        case item_filter_option_type_1.default.SHORT_TEXT:
          {
            if (type === column_type_1.default.SHORT) {
              var _compare = selected.compare;
              var option = selected.option;
              var _input6 = column.input;

              if (_compare.equal) {
                if (_input6 === option) {
                  return true;
                }
              }
            }

            break;
          }

        case item_filter_option_type_1.default.LONG:
          {
            console.warn("Long column is being filtered in selected list, which is unexpected");
            return false;
          }

        case item_filter_option_type_1.default.NUMBER:
          {
            if (type === column_type_1.default.NUMBER) {
              var _compare2 = selected.compare;
              var _option = selected.option;
              var _input7 = column.input;
              var equal = _compare2.equal,
                  larger = _compare2.larger,
                  smaller = _compare2.smaller;

              if (equal) {
                if (larger) {
                  if (_input7 >= _option) {
                    return true;
                  }
                } else if (smaller) {
                  if (_input7 <= _option) {
                    return true;
                  }
                } else {
                  if (_input7 === _option) {
                    return true;
                  }
                }
              } else {
                if (larger && _input7 > _option || smaller && _input7 < _option) {
                  return true;
                }
              }
            }

            break;
          }

        case item_filter_option_type_1.default.RELATION:
          {
            if (type === column_type_1.default.RELATION) {
              var _compare3 = selected.compare;
              var _option2 = selected.option;
              var _input8 = column.input;

              if (_compare3.equal && lodash_1.default.isEqual(_option2, _input8)) {
                return false;
              }
            }

            break;
          }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
}

exports.checkIfColumnSuitAnyOfSelectedList = checkIfColumnSuitAnyOfSelectedList;

function checkIfColumnSuitAnyOfUserInput(column, userInput, items) {
  var type = column.type;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = userInput.list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var userInputRow = _step3.value;
      var meta = userInput.meta;

      switch (meta.type) {
        case item_filter_option_type_1.default.NUMBER:
          {
            if (type === column_type_1.default.NUMBER) {
              var option = userInputRow.option,
                  compare = userInputRow.compare;
              var input = column.input;
              var equal = compare.equal,
                  larger = compare.larger,
                  smaller = compare.smaller;

              if (equal) {
                if (larger) {
                  if (input >= option) {
                    return true;
                  }
                } else if (smaller) {
                  if (input <= option) {
                    return true;
                  }
                } else {
                  if (input === option) {
                    return true;
                  }
                }
              } else {
                if (larger && input > option || smaller && input < option) {
                  return true;
                }
              }
            }

            break;
          }

        case item_filter_option_type_1.default.RATE:
          {
            if (type === column_type_1.default.RATE) {
              var _option3 = userInputRow.option,
                  _compare4 = userInputRow.compare;
              var value = lodash_1.default.get(column, 'input.value', null);

              if (value !== null) {
                var _equal = _compare4.equal,
                    _larger = _compare4.larger,
                    _smaller = _compare4.smaller;

                if (_equal) {
                  if (_larger) {
                    if (value >= _option3) {
                      return true;
                    }
                  } else if (_smaller) {
                    if (value <= _option3) {
                      return true;
                    }
                  } else {
                    if (value === _option3) {
                      return true;
                    }
                  }
                } else {
                  if (_larger && value > _option3 || _smaller && value < _option3) {
                    return true;
                  }
                }
              }
            }

            break;
          }

        case item_filter_option_type_1.default.SHORT_TEXT:
          {
            if (type === column_type_1.default.SHORT) {
              var _option4 = userInputRow.option,
                  _compare5 = userInputRow.compare;
              var _input9 = column.input;

              if (_compare5.include && _input9.includes(_option4)) {
                return true;
              }

              if (_compare5.equal && _input9 === _option4) {
                return true;
              }
            }

            break;
          }

        case item_filter_option_type_1.default.LONG:
          {
            if (type === column_type_1.default.LONG) {
              var _option5 = userInputRow.option,
                  _compare6 = userInputRow.compare;
              var _input10 = column.input;

              if (_compare6.include && _input10.includes(_option5)) {
                return true;
              }
            }

            break;
          }

        case item_filter_option_type_1.default.RELATION:
          {
            if (type === column_type_1.default.RELATION) {
              var _option6 = userInputRow.option,
                  _compare7 = userInputRow.compare,
                  userInputRowLabel = userInputRow.label;
              var _column$input = column.input,
                  target_id = _column$input.target_id,
                  target_type = _column$input.target_type;
              var relatedItem = lodash_1.default.find(items, {
                id: target_id
              });

              if (relatedItem) {
                var rows = relatedItem.rows;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = rows[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var row = _step4.value;
                    var rowLabel = row.label;

                    if (rowLabel) {
                      var targetItemRowLabel = rowLabel.content;

                      if (targetItemRowLabel === userInputRowLabel) {
                        var columns = row.content.columns;
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                          for (var _iterator5 = columns[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var _column = _step5.value;

                            switch (_column.type) {
                              case column_type_1.default.SHORT:
                              case column_type_1.default.LONG:
                                {
                                  var columnInput = _column.input;

                                  if (_compare7.equal && columnInput === _option6) {
                                    return true;
                                  }

                                  if (_compare7.include && _option6 !== null && columnInput.includes(_option6)) {
                                    return true;
                                  }

                                  break;
                                }

                              case column_type_1.default.BOOLEAN:
                                {
                                  var _columnInput = _column.input;

                                  if (_compare7.on === 0 && !_columnInput) {
                                    return true;
                                  }

                                  if (_compare7.on === 1 && _columnInput) {
                                    return true;
                                  }

                                  break;
                                }

                              case column_type_1.default.NUMBER:
                                {
                                  var _columnInput2 = _column.input;

                                  if (lodash_1.default.isString(_option6) && validator_1.default.isNumeric(_option6)) {
                                    var parsedOption = lodash_1.default.toNumber(_option6);

                                    if (_compare7.equal) {
                                      if (_compare7.larger) {
                                        if (_columnInput2 >= parsedOption) {
                                          return true;
                                        }
                                      } else {
                                        if (_columnInput2 === parsedOption) {
                                          return true;
                                        }
                                      }

                                      if (_compare7.smaller) {
                                        if (_columnInput2 <= parsedOption) {
                                          return true;
                                        }
                                      } else {
                                        if (_columnInput2 === parsedOption) {
                                          return true;
                                        }
                                      }
                                    } else if (_compare7.larger) {
                                      if (_columnInput2 > parsedOption) {
                                        return true;
                                      }
                                    } else if (_compare7.smaller) {
                                      if (_columnInput2 < parsedOption) {
                                        return true;
                                      }
                                    }
                                  } else {
                                    console.warn("Unexpected input format");
                                  }

                                  break;
                                }
                            }
                          }
                        } catch (err) {
                          _didIteratorError5 = true;
                          _iteratorError5 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                              _iterator5.return();
                            }
                          } finally {
                            if (_didIteratorError5) {
                              throw _iteratorError5;
                            }
                          }
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }
              }
            }

            break;
          }
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return false;
}

exports.checkIfColumnSuitAnyOfUserInput = checkIfColumnSuitAnyOfUserInput;

function checkIfPreview(columns) {
  for (var i = 0; i < columns.length; i++) {
    var column = columns[i];

    switch (column.type) {
      case column_type_1.default.SHORT:
        {
          var input = column.input + '';

          if (validator_1.default.isURL(input)) {
            return true;
          }

          break;
        }

      case column_type_1.default.NUMBER:
      case column_type_1.default.LONG:
      case column_type_1.default.BOOLEAN:
      default:
        return false;
    }
  }

  return false;
}

exports.checkIfPreview = checkIfPreview;

function getRelatedItemIds(columns) {
  return columns.reduce(function (accu, column) {
    if (column.type === column_type_1.default.RELATION) {
      var input = column.input;

      if (input !== null && input.target_type === 'ITEM') {
        return lodash_1.default.concat(accu, input.target_id);
      } else {
        return accu;
      }
    } else {
      return accu;
    }
  }, []);
}

exports.getRelatedItemIds = getRelatedItemIds;

function getSubinfoBySort(column, sortId) {
  var type = column.type;

  switch (type) {
    case column_type_1.default.SHORT:
      {
        var input = column.input;
        return input;
      }

    case column_type_1.default.NUMBER:
      {
        var _input11 = column.input;
        return _input11 + '';
      }

    case column_type_1.default.RATE:
      {
        var _input12 = column.input;
        var value = lodash_1.default.get(_input12, 'value', null);

        if (value !== null && lodash_1.default.isFinite(value)) {
          return value + '';
        } else {
          return '';
        }
      }

    case column_type_1.default.BOOLEAN:
      {
        var _input13 = column.input;
        return _input13 ? 'on' : 'off';
      }

    default:
      {
        console.error("can not identify type ".concat(type));
        return '';
      }
  }
}

exports.getSubinfoBySort = getSubinfoBySort;

function getTitles(columns) {
  var result = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = columns[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var column = _step6.value;
      var title = lodash_1.default.get(column, 'label.content', null);

      if (title !== null) {
        result.push(title);
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return result;
}

exports.getTitles = getTitles;

function getQuickFilterOptionContent(columns, option) {
  if (columns.length === 0) {
    return [];
  }

  var result = [];
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = columns[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var column = _step7.value;
      var labelStr = getLabelContent(column);
      var optionColumnTitle = option.column_title;

      if (lodash_1.default.isString(labelStr) && lodash_1.default.isString(optionColumnTitle) && labelStr === optionColumnTitle || !optionColumnTitle && !labelStr) {
        switch (column.type) {
          case column_type_1.default.SHORT:
            {
              if (column.input !== null) {
                result.push({
                  type: column_type_1.default.SHORT,
                  list: [column.input]
                });
              }

              break;
            }

          case column_type_1.default.NUMBER:
            {
              if (column.input !== null) {
                result.push({
                  type: column_type_1.default.NUMBER,
                  list: [column.input]
                });
              }

              break;
            }

          case column_type_1.default.BOOLEAN:
            {
              result.push({
                type: column_type_1.default.BOOLEAN
              });
              break;
            }

          case column_type_1.default.RATE:
            {
              result.push({
                type: column_type_1.default.RATE
              });
              break;
            }

          default:
            continue;
        }
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return result;
}

exports.getQuickFilterOptionContent = getQuickFilterOptionContent;

function getLabelContent(column) {
  return lodash_1.default.get(column, 'label.content', null);
}

exports.getLabelContent = getLabelContent;

function checkIfSuitQuickFilter(columns, query) {
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = columns[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var column = _step8.value;

      if (checkIfTitleSuitQuickFilter(column, query)) {
        switch (column.type) {
          case column_type_1.default.SHORT:
            {
              var selected = query.selected;

              if (selected.length === 0) {
                console.error("selected in SHORT column is empty list");
              }

              if (selected.indexOf(column.input) !== -1) {
                return true;
              }

              break;
            }

          case column_type_1.default.NUMBER:
            {
              var _selected = query.selected;

              if (_selected.length === 0) {
                console.error("selected in NUMBER column is empty list");
              }

              if (_selected.indexOf(column.input) !== -1) {
                return true;
              }

              break;
            }

          case column_type_1.default.BOOLEAN:
            {
              var _selected2 = query.selected;

              if (column.input === _selected2) {
                return true;
              }

              break;
            }

          case column_type_1.default.RATE:
            {
              var _selected3 = query.selected;

              if (!lodash_1.default.isNumber(_selected3)) {
                console.error("".concat(_selected3, " is not a number"));
                break;
              }

              var value = lodash_1.default.get(column, 'input.value', null);

              if (value === null) {
                console.error("".concat(column, " has no input.value"));
                break;
              }

              if (value === _selected3) {
                return true;
              }

              break;
            }
        }
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return false;
}

exports.checkIfSuitQuickFilter = checkIfSuitQuickFilter;

function checkIfTitleSuitQuickFilter(column, query) {
  var queryTitle = lodash_1.default.get(query, 'option.column_title', null);
  var columnTitle = getLabelContent(column);

  if (!!queryTitle) {
    if (!!columnTitle && queryTitle === columnTitle) {
      return true;
    }
  } else {
    if (!columnTitle) {
      return true;
    }
  }

  return false;
}

exports.checkIfTitleSuitQuickFilter = checkIfTitleSuitQuickFilter;

function createByStructures(structures) {
  return structures.reduce(function (acc, cur) {
    var type = cur.type,
        title = cur.title;
    var label = !!title ? UtilsLabel.create(title) : null;
    return lodash_1.default.concat(acc, _objectSpread({
      label: label
    }, getDefault(type)));
  }, []);
}

exports.createByStructures = createByStructures;

function getDefault(type) {
  switch (type) {
    case column_type_1.EnumColumnType.NUMBER:
      return {
        type: column_type_1.EnumColumnType.NUMBER,
        input: 0
      };

    case column_type_1.EnumColumnType.BOOLEAN:
      return {
        type: column_type_1.EnumColumnType.BOOLEAN,
        input: true
      };

    case column_type_1.EnumColumnType.LONG:
      return {
        type: column_type_1.EnumColumnType.LONG,
        input: ''
      };

    case column_type_1.EnumColumnType.RATE:
      return {
        type: column_type_1.EnumColumnType.RATE,
        input: {
          value: 0
        }
      };

    case column_type_1.EnumColumnType.RELATION:
      return {
        type: column_type_1.EnumColumnType.RELATION,
        input: null
      };

    case column_type_1.EnumColumnType.SHORT:
    default:
      return {
        type: column_type_1.EnumColumnType.SHORT,
        input: ''
      };
  }
}

exports.getDefault = getDefault;

function getSortComparator(column, columnGroup) {
  var title = getLabelContent(column);
  var column_title = columnGroup.column_title;

  if (title !== column_title) {
    return null;
  }

  switch (column.type) {
    case column_type_1.EnumColumnType.SHORT:
    case column_type_1.EnumColumnType.LONG:
      return column.input;

    case column_type_1.EnumColumnType.NUMBER:
      return column.input;

    case column_type_1.EnumColumnType.RATE:
      return lodash_1.default.get(column, 'input.value', null);

    case column_type_1.EnumColumnType.BOOLEAN:
      return !!column.input ? 0 : 1;

    default:
      return null;
  }
}

exports.getSortComparator = getSortComparator;

function getSortInfo(column, columnGroup) {
  var title = getLabelContent(column);

  if (title !== columnGroup.column_title) {
    return null;
  }

  switch (column.type) {
    case column_type_1.EnumColumnType.SHORT:
      return column.input;

    case column_type_1.EnumColumnType.NUMBER:
      return column.input + '';

    case column_type_1.EnumColumnType.RATE:
      return lodash_1.default.get(column, 'input.value', '') + '';

    case column_type_1.EnumColumnType.BOOLEAN:
      return !!column.input ? 'T' : 'F';

    default:
      return null;
  }
}

exports.getSortInfo = getSortInfo;

function addLabel(column, content) {
  return Object.assign({}, column, {
    label: UtilsLabel.create(content)
  });
}

exports.addLabel = addLabel;